import React, { useRef, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Paper } from '@mui/material';
import Draggable from 'react-draggable';
import { useReactToPrint } from 'react-to-print';

import EstimateWriteDialog from './EstimateWriteDialog';
import EstimateDetailContent from './EstimateDetailContent';


// PaperComponent에 nodeRef를 사용하여 Draggable에 전달
// React18 버전 이후로 ref를 직접 전달해야 드래그에이블 사용 가능
const PaperComponent = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable 
      nodeRef={nodeRef} 
      handle=".dialog-title" 
      cancel={'[class*="MuiDialogContent-root"]'} // 드래그 불가능한 구역 설정가능(컨텐트 부분 드래그불가)
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

const DraggableDialog = ({ open, onClose, estimate, onUpdate }) => {
  const [writeDialogOpen, setWriteDialogOpen] = useState(false);
  const printRef = useRef();

  const handleWriteClick = () => {
    onClose(); // 현재 다이얼로그 닫기
    setWriteDialogOpen(true); // 수정 다이얼로그 열기
  };

  // 수정 다이얼로그가 onClose(savedDto) 하면 여기로
  const handleWriteClose = (savedDto) => {
    setWriteDialogOpen(false);
    // 저장한 DTO가 있으면 그것으로, 아니면 기존 estimate 그대로 넘겨서
    // 항상 미리보기 모달을 다시 열도록 onUpdate 호출
    const dtoToPreview = savedDto ?? estimate;
    onUpdate(dtoToPreview);                // 항상 미리보기 오픈 콜백
  };

  // PDF 출력 핸들러
  // ← pass contentRef, not content()
  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: `${estimate?.clientCompany}_${estimate?.estimateNumber}`,
    removeAfterPrint: true,
    copyStyles: true,
    pageStyle: `
      @page {
        size: A4 portrait;
        /* 프린터 안전여백(예: 상하좌우 5mm) 만큼 마진을 줍니다 */
        margin: 5mm;
      }
      @media print {
        html, body {
          margin: 0;
          -webkit-print-color-adjust: exact;
        }
        /* 실제 인쇄 영역에 맞춰 컨테이너 크기 조정 */
        #print-container {
          box-sizing: border-box;
          width: 100%;
          height: auto;
          padding: 0;
        }
      }
    `
  });

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        PaperComponent={PaperComponent}
        maxWidth="xl"
      >
        <DialogTitle className="dialog-title" style={{ cursor: 'move', textAlign: 'center' }}>
          견적서 상세 정보
        </DialogTitle>
        <DialogContent>
          <div
            id="print-container"
            ref={printRef}
            style={{
              minWidth: '210mm',
              minHeight: '297mm',
              padding: '0',
              margin: 0
            }}
          >
            {/* 수정모달에서 디테일컨텐트에 formValues로 전달하기 때문에 formValues로 전달 */}
            <EstimateDetailContent id={estimate?.id} formValues={estimate} materialRows={estimate?.estimateMaterials}/>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>닫기</Button>
          <Button onClick={handleWriteClick} variant="contained" color="primary">
            수정
          </Button>
          <Button variant="contained" color="secondary" onClick={handlePrint}>
            PDF 출력
          </Button>
        </DialogActions>
      </Dialog>

      <EstimateWriteDialog
        open={writeDialogOpen}
        onClose={handleWriteClose}
        estimate={estimate}
      />
    </>
  );
};

export default DraggableDialog;